<template>
  <svg
    id="icon-x"
    :width="width"
    :height="height"
    viewBox="0 0 25 25"
    :fill="fill"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M18.3263 1.90625H21.6998L14.3297 10.3297L23 21.7922H16.2112L10.894 14.8403L4.80995 21.7922H1.43443L9.31743 12.7823L1 1.90625H7.96111L12.7674 8.26058L18.3263 1.90625ZM17.1423 19.773H19.0116L6.94539 3.81938H4.93946L17.1423 19.773Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "../mixins/icons";

export default {
  name: "IconX",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
